import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import { ContentItemBase } from 'FoldersApp/directives/content-item-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/item-selection.service";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i3 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i4 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i7 from "@angular/common";
import * as i8 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
import * as i9 from "../../../../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i10 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
function AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "div", 6);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 2, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 5, folder_r1));
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-analysis-plan-select-saved-list-item", 8);
} if (rf & 2) {
    const folderable_r2 = ctx.folderable;
    const ancestorInfo_r3 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r2)("ancestorInfo", ancestorInfo_r3);
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span");
    i0.ɵɵtext(2, "There are no interactive analysis plans in this folder.");
    i0.ɵɵelementEnd()();
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 4, 0);
    i0.ɵɵtemplate(2, AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_2_Template, 6, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_4_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, AnalysisPlanSelectSavedListItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r4 = i0.ɵɵreference(3);
    const listItemFragment_r5 = i0.ɵɵreference(5);
    const emptyFolderFragment_r6 = i0.ɵɵreference(7);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r6.folderable)("ancestorInfo", ctx_r6.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r4)("listItemFragment", listItemFragment_r5)("emptyFolderFragment", emptyFolderFragment_r6);
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r6.savedPlan));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "label", 13)(3, "input", 14);
    i0.ɵɵlistener("click", function AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.bulkActionSelectionService.toggleSelectedItem(ctx_r6.folderable.resourceType, ctx_r6.savedPlan.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 16)(6, "div", 17)(7, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 19);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 20);
    i0.ɵɵtext(10, "ia");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 21);
    i0.ɵɵlistener("click", function AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r8); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.filenameClickHandler(ctx_r6.savedPlan)); });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(12, AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template, 3, 6, "div", 22);
    i0.ɵɵpipe(13, "isSharedWithOthers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 5);
    i0.ɵɵelement(15, "div", 6);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵelement(18, "div", 6);
    i0.ɵɵpipe(19, "getOwnerDisplayName");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r6.isBulkSelected);
    i0.ɵɵproperty("folderable", ctx_r6.folderable)("ancestorInfo", ctx_r6.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r6.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r6.isBulkSelected);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r6.savedPlan.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(13, 11, ctx_r6.savedPlan) ? 12 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(16, 13, ctx_r6.savedPlan.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(19, 16, ctx_r6.savedPlan));
} }
function AnalysisPlanSelectSavedListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AnalysisPlanSelectSavedListItemComponent_Conditional_1_Conditional_0_Template, 20, 18, "div", 10);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r6.bulkActionSelectionService.idsByResourceType$) ? 0 : -1);
} }
export class AnalysisPlanSelectSavedListItemComponent extends ContentItemBase {
    constructor(itemSelectionService) {
        super();
        this.itemSelectionService = itemSelectionService;
    }
    get savedPlan() {
        return this.folderable.item;
    }
    get itemSelectionEnabled() {
        return this.savedPlan.permissions?.canView ?? true;
    }
    filenameClickHandler(plan) {
        this.itemSelectionService.selectItem(plan);
    }
    fileDropdownHandler() { }
}
AnalysisPlanSelectSavedListItemComponent.ɵfac = function AnalysisPlanSelectSavedListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AnalysisPlanSelectSavedListItemComponent)(i0.ɵɵdirectiveInject(i1.ItemSelectionService)); };
AnalysisPlanSelectSavedListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnalysisPlanSelectSavedListItemComponent, selectors: [["ycn-analysis-plan-select-saved-list-item"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], [1, "file-icon", "file-ia"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["href", "javascript:void(0)", 3, "click", "textContent"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"]], template: function AnalysisPlanSelectSavedListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AnalysisPlanSelectSavedListItemComponent_Conditional_0_Template, 8, 5)(1, AnalysisPlanSelectSavedListItemComponent_Conditional_1_Template, 2, 3);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i2.DisabledDirective, i3.FolderableDirective, i4.FolderBaseComponent, i5.IconDirective, i6.TooltipDirective, AnalysisPlanSelectSavedListItemComponent, i7.AsyncPipe, i7.DatePipe, i8.GetOwnerDisplayName, i9.GetSharingTooltipMessage, i10.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
